import { SelectChangeEvent } from '@mui/material'
import { ChangeEvent, useCallback, useState } from 'react'

export const usePagination = () => {
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(25)

  const handlePageChange = useCallback((event: ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage)
  }, [])

  const handleLimitChange = useCallback((event: SelectChangeEvent<number>) => {
    const value = event.target.value as number
    setSize(value)
    setPage(1)
  }, [])

  const resetPage = useCallback(() => {
    setPage(1)
  }, [])

  return { page, size, handlePageChange, handleLimitChange, resetPage }
}
